export const countries = [
    {
        "title": "Afghanistan",
        "cities": [
            "Ghazni",
            "Herat",
            "Jalalabad",
            "Kabul",
            "Kandahar",
            "Kunduz",
            "Lashkar Gah",
            "Mazar-i-Sharif",
            "Taloqan",
            "Uruzgan"
        ]
    },
    {
        "title": "Algeria",
        "cities": [
            "Algiers",
            "Annaba",
            "Batna",
            "Blida",
            "Béjaïa",
            "Constantine",
            "Oran",
            "Skikda",
            "Sétif",
            "Tizi Ouzou"
        ]
    },
    {
        "title": "Angola",
        "cities": [
            "Benguela",
            "Cabinda",
            "Huambo",
            "Lobito",
            "Luanda",
            "Lubango",
            "Malanje",
            "N'dalatando",
            "Namibe",
            "Soyo"
        ]
    },
    {
        "title": "Argentina",
        "cities": [
            "Buenos Aires",
            "Córdoba",
            "La Plata",
            "Mar del Plata",
            "Mendoza",
            "Resistencia",
            "Rosario",
            "Salta",
            "San Miguel de Tucumán",
            "Santa Fe"
        ]
    },
    {
        "title": "Bangladesh",
        "cities": [
            "Barishal",
            "Chattogram",
            "Cumilla",
            "Dhaka",
            "Khulna",
            "Mymensingh",
            "Narayanganj",
            "Rajshahi",
            "Rangpur",
            "Sylhet"
        ]
    },
    {
        "title": "Brazil",
        "cities": [
            "Belo Horizonte",
            "Brasília",
            "Curitiba",
            "Fortaleza",
            "Manaus",
            "Porto Alegre",
            "Recife",
            "Rio de Janeiro",
            "Salvador",
            "São Paulo"
        ]
    },
    {
        "title": "Canada",
        "cities": [
            "Calgary",
            "Edmonton",
            "Hamilton",
            "Kitchener",
            "Montreal",
            "Ottawa",
            "Quebec City",
            "Toronto",
            "Vancouver",
            "Winnipeg"
        ]
    },
    {
        "title": "China",
        "cities": [
            "Beijing",
            "Chengdu",
            "Chongqing",
            "Guangzhou",
            "Nanjing",
            "Shanghai",
            "Shenzhen",
            "Tianjin",
            "Wuhan",
            "Xi'an"
        ]
    },
    {
        "title": "Colombia",
        "cities": [
            "Barranquilla",
            "Bogotá",
            "Bucaramanga",
            "Cali",
            "Cartagena",
            "Cúcuta",
            "Ibagué",
            "Medellín",
            "Pereira",
            "Santa Marta"
        ]
    },
    {
        "title": "Côte d'Ivoire",
        "cities": [
            "Abidjan",
            "Abobo",
            "Anyama",
            "Bouaké",
            "Daloa",
            "Gagnoa",
            "Korhogo",
            "Man",
            "San-Pédro",
            "Yamoussoukro"
        ]
    },
    {
        "title": "DR Congo",
        "cities": [
            "Bukavu",
            "Goma",
            "Kananga",
            "Kinshasa",
            "Kisangani",
            "Kolwezi",
            "Likasi",
            "Lubumbashi",
            "Matadi",
            "Mbuji-Mayi"
        ]
    },
    {
        "title": "Egypt",
        "cities": [
            "Alexandria",
            "Cairo",
            "El Mahalla El Kubra",
            "Giza",
            "Luxor",
            "Mansoura",
            "Port Said",
            "Shubra El-Kheima",
            "Suez",
            "Tanta"
        ]
    },
    {
        "title": "Ethiopia",
        "cities": [
            "Adama",
            "Addis Ababa",
            "Bahir Dar",
            "Dessie",
            "Dire Dawa",
            "Gondar",
            "Hawassa",
            "Jijiga",
            "Jimma",
            "Mekelle"
        ]
    },
    {
        "title": "France",
        "cities": [
            "Bordeaux",
            "Lille",
            "Lyon",
            "Marseille",
            "Montpellier",
            "Nantes",
            "Nice",
            "Paris",
            "Strasbourg",
            "Toulouse"
        ]
    },
    {
        "title": "Germany",
        "cities": [
            "Berlin",
            "Cologne",
            "Dortmund",
            "Düsseldorf",
            "Essen",
            "Frankfurt",
            "Hamburg",
            "Leipzig",
            "Munich",
            "Stuttgart"
        ]
    },
    {
        "title": "Ghana",
        "cities": [
            "Accra",
            "Ashaiman",
            "Cape Coast",
            "Koforidua",
            "Kumasi",
            "Obuasi",
            "Sekondi-Takoradi",
            "Sunyani",
            "Tamale",
            "Techiman"
        ]
    },
    {
        "title": "India",
        "cities": [
            "Ahmedabad",
            "Bangalore",
            "Chennai",
            "Delhi",
            "Hyderabad",
            "Jaipur",
            "Kolkata",
            "Mumbai",
            "Pune",
            "Surat"
        ]
    },
    {
        "title": "Indonesia",
        "cities": [
            "Bandung",
            "Bekasi",
            "Depok",
            "Jakarta",
            "Makassar",
            "Medan",
            "Palembang",
            "Semarang",
            "Surabaya",
            "Tangerang"
        ]
    },
    {
        "title": "Iran",
        "cities": [
            "Ahvaz",
            "Isfahan",
            "Karaj",
            "Kermanshah",
            "Mashhad",
            "Qom",
            "Shiraz",
            "Tabriz",
            "Tehran",
            "Urmia"
        ]
    },
    {
        "title": "Iraq",
        "cities": [
            "Amarah",
            "Baghdad",
            "Basra",
            "Erbil",
            "Karbala",
            "Kirkuk",
            "Kut",
            "Mosul",
            "Najaf",
            "Samarra"
        ]
    },
    {
        "title": "Italy",
        "cities": [
            "Bari",
            "Bologna",
            "Catania",
            "Florence",
            "Genoa",
            "Milan",
            "Naples",
            "Palermo",
            "Rome",
            "Turin"
        ]
    },
    {
        "title": "Japan",
        "cities": [
            "Fukuoka",
            "Kawasaki",
            "Kobe",
            "Kyoto",
            "Nagoya",
            "Osaka",
            "Saitama",
            "Sapporo",
            "Tokyo",
            "Yokohama"
        ]
    },
    {
        "title": "Kenya",
        "cities": [
            "Eldoret",
            "Garissa",
            "Kisumu",
            "Kitale",
            "Machakos",
            "Meru",
            "Mombasa",
            "Nairobi",
            "Nakuru",
            "Thika"
        ]
    },
    {
        "title": "Madagascar",
        "cities": [
            "Ambatondrazaka",
            "Antananarivo",
            "Antsirabe",
            "Diego Suarez",
            "Fenoarivo Atsinanana",
            "Fianarantsoa",
            "Mahajanga",
            "Moramanga",
            "Toamasina",
            "Toliara"
        ]
    },
    {
        "title": "Malaysia",
        "cities": [
            "Alor Setar",
            "George Town",
            "Ipoh",
            "Johor Bahru",
            "Kota Kinabalu",
            "Kuala Lumpur",
            "Kuching",
            "Malacca City",
            "Petaling Jaya",
            "Shah Alam"
        ]
    },
    {
        "title": "Mexico",
        "cities": [
            "Ciudad Juárez",
            "Guadalajara",
            "León",
            "Mexico City",
            "Monterrey",
            "Puebla",
            "San Luis Potosí",
            "Tijuana",
            "Toluca",
            "Torreón"
        ]
    },
    {
        "title": "Morocco",
        "cities": [
            "Agadir",
            "Casablanca",
            "Fes",
            "Kénitra",
            "Marrakech",
            "Meknes",
            "Oujda",
            "Rabat",
            "Tangier",
            "Tetouan"
        ]
    },
    {
        "title": "Mozambique",
        "cities": [
            "Beira",
            "Chimoio",
            "Maputo",
            "Matola",
            "Nacala",
            "Nampula",
            "Pemba",
            "Quelimane",
            "Tete",
            "Xai-Xai"
        ]
    },
    {
        "title": "Myanmar",
        "cities": [
            "Bago",
            "Mandalay",
            "Mawlamyine",
            "Monywa",
            "Myitkyina",
            "Naypyidaw",
            "Pathein",
            "Pyay",
            "Taunggyi",
            "Yangon"
        ]
    },
    {
        "title": "Nigeria",
        "cities": [
            "Aba",
            "Abuja",
            "Benin City",
            "Ibadan",
            "Jos",
            "Kano",
            "Lagos",
            "Maiduguri",
            "Port Harcourt",
            "Zaria"
        ]
    },
    {
        "title": "Pakistan",
        "cities": [
            "Faisalabad",
            "Gujranwala",
            "Islamabad",
            "Karachi",
            "Lahore",
            "Multan",
            "Peshawar",
            "Rawalpindi",
            "Sargodha",
            "Sialkot"
        ]
    },
    {
        "title": "Peru",
        "cities": [
            "Arequipa",
            "Chiclayo",
            "Chimbote",
            "Cusco",
            "Huancayo",
            "Iquitos",
            "Lima",
            "Piura",
            "Tacna",
            "Trujillo"
        ]
    },
    {
        "title": "Philippines",
        "cities": [
            "Antipolo",
            "Cagayan de Oro",
            "Caloocan",
            "Cebu City",
            "Davao City",
            "Manila",
            "Pasig",
            "Quezon City",
            "Taguig",
            "Zamboanga City"
        ]
    },
    {
        "title": "Poland",
        "cities": [
            "Bydgoszcz",
            "Gdańsk",
            "Katowice",
            "Kraków",
            "Lublin",
            "Poznań",
            "Szczecin",
            "Warsaw",
            "Wrocław",
            "Łódź"
        ]
    },
    {
        "title": "Russia",
        "cities": [
            "Chelyabinsk",
            "Kazan",
            "Moscow",
            "Nizhny Novgorod",
            "Novosibirsk",
            "Omsk",
            "Rostov-on-Don",
            "Saint Petersburg",
            "Samara",
            "Yekaterinburg"
        ]
    },
    {
        "title": "Saudi Arabia",
        "cities": [
            "Al Khobar",
            "Buraidah",
            "Dammam",
            "Jeddah",
            "Khamis Mushait",
            "Mecca",
            "Medina",
            "Riyadh",
            "Ta'if",
            "Tabuk"
        ]
    },
    {
        "title": "South Africa",
        "cities": [
            "Bloemfontein",
            "Cape Town",
            "Durban",
            "East London",
            "Johannesburg",
            "Nelspruit",
            "Pietermaritzburg",
            "Polokwane",
            "Port Elizabeth",
            "Pretoria"
        ]
    },
    {
        "title": "South Korea",
        "cities": [
            "Busan",
            "Daegu",
            "Daejeon",
            "Goyang",
            "Gwangju",
            "Incheon",
            "Seongnam",
            "Seoul",
            "Suwon",
            "Ulsan"
        ]
    },
    {
        "title": "Spain",
        "cities": [
            "Barcelona",
            "Bilbao",
            "Las Palmas",
            "Madrid",
            "Murcia",
            "Málaga",
            "Palma",
            "Seville",
            "Valencia",
            "Zaragoza"
        ]
    },
    {
        "title": "Sudan",
        "cities": [
            "Al-Fashir",
            "Dongola",
            "El Obeid",
            "Kassala",
            "Khartoum",
            "Kosti",
            "Nyala",
            "Omdurman",
            "Port Sudan",
            "Wad Madani"
        ]
    },
    {
        "title": "Tanzania",
        "cities": [
            "Arusha",
            "Dar es Salaam",
            "Dodoma",
            "Kigoma",
            "Mbeya",
            "Morogoro",
            "Mwanza",
            "Shinyanga",
            "Tabora",
            "Tanga"
        ]
    },
    {
        "title": "Thailand",
        "cities": [
            "Bangkok",
            "Chiang Mai",
            "Hat Yai",
            "Khon Kaen",
            "Nakhon Ratchasima",
            "Nakhon Si Thammarat",
            "Nonthaburi",
            "Phuket",
            "Samut Prakan",
            "Udon Thani"
        ]
    },
    {
        "title": "Turkey",
        "cities": [
            "Adana",
            "Ankara",
            "Antalya",
            "Bursa",
            "Gaziantep",
            "Istanbul",
            "İzmir",
            "Kayseri",
            "Konya",
            "Mersin"
        ]
    },
    {
        "title": "Uganda",
        "cities": [
            "Fort Portal",
            "Jinja",
            "Kampala",
            "Kira",
            "Lira",
            "Mbale",
            "Mbarara",
            "Mukono",
            "Nansana",
            "Wakiso"
        ]
    },
    {
        "title": "Ukraine",
        "cities": [
            "Dnipro",
            "Donetsk",
            "Kharkiv",
            "Kryvyi Rih",
            "Kyiv",
            "Lviv",
            "Mariupol",
            "Mykolaiv",
            "Odesa",
            "Zaporizhzhia"
        ]
    },
    {
        "title": "United Kingdom",
        "cities": [
            "Birmingham",
            "Bristol",
            "Edinburgh",
            "Glasgow",
            "Leeds",
            "Leicester",
            "Liverpool",
            "London",
            "Manchester",
            "Sheffield"
        ]
    },
    {
        "title": "United States",
        "cities": [
            "Chicago",
            "Dallas",
            "Houston",
            "Los Angeles",
            "New York",
            "Philadelphia",
            "Phoenix",
            "San Antonio",
            "San Diego",
            "San Jose"
        ]
    },
    {
        "title": "Uzbekistan",
        "cities": [
            "Andijan",
            "Bukhara",
            "Fergana",
            "Karshi",
            "Namangan",
            "Navoiy",
            "Nukus",
            "Qo'qon",
            "Samarkand",
            "Tashkent"
        ]
    },
    {
        "title": "Vietnam",
        "cities": [
            "Bien Hoa",
            "Buon Ma Thuot",
            "Can Tho",
            "Da Nang",
            "Haiphong",
            "Hanoi",
            "Ho Chi Minh City",
            "Nha Trang",
            "Thanh Hoa",
            "Vung Tau"
        ]
    },
    {
        "title": "Yemen",
        "cities": [
            "Aden",
            "Al Bayda",
            "Al Hudaydah",
            "Amran",
            "Dhamar",
            "Ibb",
            "Mukalla",
            "Sa'dah",
            "Sana'a",
            "Taiz"
        ]
    }
];
